import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { Body2 } from '../../typography';
const NoWrap = styled(Body2) `
  white-space: nowrap;
`;
export const Watermark = ({ imageUrl, provider }) => {
    const [imgError, setImgError] = useState(false);
    const setError = useCallback(() => {
        setImgError(true);
    }, []);
    return imgError ? (React.createElement(NoWrap, null, provider)) : (React.createElement("img", { src: imageUrl, alt: "Watermark", onError: setError }));
};
